import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment';
import { PageHeader, Menu, Dropdown, Button, Tag, Card, Row } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import {getAttendances} from '../actions/attendance';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { axiosConfig, SERVER_PATH } from '../actions/common';


const arr ={
    3:'Absent with notice',
    4:'Late to school',
    5:'Absent no notice',
    6:'HalfDay',
}
const Reports = (props) => {


    const nav = useNavigate()
    const loc = useLocation()
    let pr = useParams()
    let sessionid = pr.index1
    const {mid} = props || ''
  

    let val = loc.state
    let {data:dtr, classdata, reportname} = val
    let {termid} = dtr

    const [sessions, setsessions] = useState({})
    const [terms, setterms] = useState({})

    useEffect(() => {
        let params = {
            data:JSON.stringify(
            {
                  'id':termid
            }),
              cat:'selected',
              table:'terms',
              narration:'get term'
        }
        axios.get(SERVER_PATH, {params}, axiosConfig)
        .then(res=>setterms(res.data[0]))
        .catch(err=>{})

    }, [termid])

    useEffect(() => {
        let {started, ended} = terms
        let params = {
            data:JSON.stringify(
            {
                  'sessionid':sessionid,
                  'termid':termid,
                  'studentid' : mid,
                  'starts':started,
                  'ends':ended
              }),
              cat:'selected_attendance',
              table:'studentscore',
              narration:'get attendances'
            }
            props.getAttendances(params)
     
    }, [terms])
    
    
    const get_rows = (id, arrays) =>{
         return arrays[id]
    }
    
  
    let arr_reports = []
    Object.keys(props.reports).forEach(schoolid=>{
        let sessions = props.reports[schoolid]
        Object.keys(sessions).forEach(sessionid=>{
            let terms = sessions[sessionid]
            Object.keys(terms).forEach(termid=>{
                let arr = {}
                let sch = get_rows(schoolid, props.schools)
                let ses = get_rows(sessionid, props.sessions)
                let tem = get_rows(termid, props.terms)
                arr['schoolname'] = sch.abbrv || ''
                arr['sessionname'] = ses.name+" "+tem.name || ''
                arr['schooldata'] = sch
                arr['termdata'] = tem
                arr['sessiondata'] = ses
                arr_reports.push(arr)   
            })           
        })
    })
    const loadResult = (d) =>{
        setsessions(d.sessiondata)
        setterms(d.termdata)
        let session = d.sessiondata.id
        let term = d.termdata.id
        let start = d.termdata.started
        let end = d.termdata.ended
        let params = {
            data:JSON.stringify(
            {
                  'sessionid':session,
                  'termid':term,
                  'studentid' : props.mid,
                  'starts':start,
                  'ends':end
              }),
              cat:'selected_attendance',
              table:'studentscore',
              narration:'get attendances'
            }
            props.getAttendances(params)

    }
   
    const menu = (
        <Menu>
            {
                arr_reports.map((prop, index)=>{
                    return <Menu.Item 
                        key={index} 
                        onClick={()=>loadResult(prop)}
                    >
                      {`${prop.schoolname} ${prop.sessionname}`}
                  </Menu.Item>
                })
            }
        </Menu>
      );

    

    const DropdownMenu = () => (
        <Dropdown key="more" overlay={menu}>
          <Button>
            <EllipsisOutlined
              style={{
                fontSize: 20,
                verticalAlign: 'top',
              }} 
            /> Select Term
          </Button>
        </Dropdown>
    );

    const data = Array.isArray(Object.keys(props.attendance)) ? props.attendance[0] || [] : []
    const data1 = Array.isArray(Object.keys(props.attendance)) ? props.attendance[1] || [] : []
    
   
var getdates_present = [];
var getdates_absent = [];
let attend_array = {}
if(Array.isArray(data)){
    data.forEach(prop =>{
    let res = prop.reason.split(",");
    if(res.includes(mid))
    {
        attend_array[prop.dates] = 'Present'
        getdates_present.push(prop.dates);
    } else{
        if(attend_array.hasOwnProperty(prop.dates)){
            
        }else{
            attend_array[prop.dates] = 'Not in School'
            getdates_absent.push(prop.dates);
        }
        
    }
})
}

const others = {}
if(Array.isArray(data1)){
data1.forEach(prop =>{
    attend_array[prop.dates] = arr[prop.leaveid] || 'Null'
    if(others.hasOwnProperty(prop.leaveid)){
        others[prop.leaveid].push(prop.dates)
    }else{
        others[prop.leaveid] = []
        others[prop.leaveid].push(prop.dates)
    }
      
})
}

let absent1 = Array.isArray(others[3]) ? others[3].length : 0 //absent with notice
let absent2 = Array.isArray(others[5]) ?  others[5].length : 0 //absent no notice
let absent3 = Array.isArray(others[6]) ?  others[6].length : 0 //halfday
let late = Array.isArray(others[4]) ?  others[4].length : 0
let total_present = [...new Set(getdates_present)].length
let total_absent = [...new Set(getdates_absent)].length
let total_days = getdates_present.concat(getdates_absent)
total_days = [...new Set(total_days)].length
console.log(total_present, total_absent)
  
    return (
        <div>
            <PageHeader
                title="Attendances"
                className="site-page-header no-print"
                subTitle={sessions.name || '-'}
                tags={<Tag color="blue">Active</Tag>}
                extra={[
                    <Button onClick={()=>nav(-1)}>Go Back</Button>,
                ]}
                avatar={{ src: process.env.PUBLIC_URL+'/asset/icons/class.png' }}    
            ></PageHeader>
            <Card>
                <h2 className="text-left">{`${terms.name || '-'} ${terms.name || '-'}`}</h2>
                <h5 className="text-left">{`${moment(terms.started).format('Do MMM YYYY')} to ${moment(terms.ended).format('Do MMM YYYY')} `}</h5>
        
        <Row style={{alignItems:'center'}}>
            <div xs={24} sm={12} md={12} className="ca-data-card" style={{minWidth:'300px'}}>
                    <h3 className="ca-h3"> {total_days}</h3>
                    <h4 className="ca-h4">Days</h4>
                </div>
            <div xs={24} sm={12} md={12} className="ca-data-card" style={{minWidth:'300px'}}>
                    <h3 className="ca-h3"> {`${total_present} (${Number((total_present/total_days) * 100).toFixed(0)}%)`}</h3>
                    <h4 className="ca-h4">Attendance</h4>
                </div>
            <div xs={24} sm={12} md={12} className="ca-data-card" style={{minWidth:'300px'}}>
                    <h3 className="ca-h3"> {absent1}</h3>
                    <h4 className="ca-h4">Absent with notice</h4>
                </div>
                <div xs={24} sm={12} md={12} className="ca-data-card" style={{minWidth:'300px'}}>
                    <h3 className="ca-h3"> {absent2}</h3>
                    <h4 className="ca-h4">Absent no notice</h4>
                </div>
                <div xs={24} sm={12} md={12} className="ca-data-card" style={{minWidth:'300px'}}>
                    <h3 className="ca-h3"> {absent3}</h3>
                    <h4 className="ca-h4">Half day</h4>
                </div>
            <div xs={24} sm={12} md={12} className="ca-data-card" style={{minWidth:'300px'}}>
                    <h3 className="ca-h3"> {late}</h3>
                    <h4 className="ca-h4">Resumed Late</h4>
                </div>
        </Row>
        <Card type="inner">
            <table width="100%" border="1px solid black">
                <thead>
                    <tr>
                        <th>SN</th>
                        <th>DATE</th>
                        <th>STATUS</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        Object.keys(attend_array).map((ele, indx)=>{
                            return <tr style={{color: attend_array[ele] == 'Present' ? 'green' :'red', fontWeight:'bold'}}>
                                <td border="1px solid black" className='text-center'>{indx + 1}</td>
                                <td border="1px solid black" className='text-left'>{moment(ele).format('Do dddd MMMM yyyy')}</td>
                                <td border="1px solid black">{attend_array[ele]}</td>
                            </tr>
                        })
                    }
                </tbody>
            </table>
                   
        </Card>
        </Card>
        </div>
    )
}

const mapStateToProps = (state) => ({
    reports:state.reportReducer.reports,
    attendance:state.attendanceReducer.attendances,
    schools:state.reportReducer.schools,
    sessions:state.reportReducer.sessions,
    terms:state.reportReducer.terms,
    studentreport:state.studentreportReducer.studentreports,
    mid:state.userReducer.mid
})

const mapDispatchToProps = {
    getAttendances
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
